import { ReactComponent as DishCoverSvg } from '../../assets/icons/dish-cover.svg';

export const DishCoverIcon: SvgIcon = (props) => {
    return <DishCoverSvg {...props} />;
};
